
function amazing_init0(index) {
    var scripts = document.getElementsByTagName("script");
    var jsFolder = "";
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.match(/amazinginit72\.js/i))
          jsFolder = scripts[i].src.substr(0, scripts[i].src.lastIndexOf("/") + 1)
    }
    var width = document.documentElement.clientWidth;
  
    jQuery("#amazingslider-" + index).amazingslider72({
        sliderid: 1,
        addgooglefonts: false,
        addmargin: false,
        arrowheight: 32,
        arrowhideonmouseleave: 1000,
        arrowimage: "arrows-32-32-42.png",
        arrowmargin: 8,
        arrowstyle: "mouseover",
        arrowtop: 50,
        arrowwidth: 32,
        autoplay: false,
        autoplayvideo: true,
        backgroundimage: "",
        backgroundimagetop: -10,
        backgroundimagewidth: 120,
        border: 0,
        bordercolor: "#ffffff",
        borderradius: 0,
        bottomshadowimage: "bottomshadow-110-95-0.png",
        bottomshadowimagetop: 95,
        bottomshadowimagewidth: 96,
        buttoncss: "display:block; position:relative; margin-top:8px;",
        buttoncssresponsive: "",
        customcss: "",
        descriptioncss: "display:block; position:relative; font:12px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff; margin-top:8px;",
        descriptioncssresponsive: "font-size:12px;",
        donotresize: false,
        enabletouchswipe: true,
        forceflash: false,
        forceflashonie10: false,
        forceflashonie11: false,
        fullscreen: false,
        fullwidth: false,
        googlefonts: "",
        height: 900,
        initsocial: false,
        isfullscreen: false,
        isresponsive: true,
        jsfolder: jsFolder,
        lightboxbarheight: 64,
        lightboxdescriptionbottomcss: "{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}",
        lightboxshowdescription: false,
        lightboxshowfacebook: true,
        lightboxshownavigation: false,
        lightboxshowpinterest: true,
        lightboxshowsocial: false,
        lightboxshowtitle: true,
        lightboxshowtwitter: true,
        lightboxthumbbottommargin: 8,
        lightboxthumbheight: 60,
        lightboxthumbtopmargin: 12,
        lightboxthumbwidth: 80,
        lightboxtitlebottomcss: "{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}",
        loadimageondemand: false,
        loop: 0,
        navarrowimage: "navarrows-20-20-1.png",
        navborder: 1,
        navbordercolor: "#000000",
        navborderhighlightcolor: "#dddddd",
        navbuttonbgimage: "navbuttonbgimage-28-28-0.png",
        navbuttoncolor: "#999999",
        navbuttonhighlightcolor: "#333333",
        navbuttonradius: 0,
        navbuttonshowbgimage: true,
        navcolor: "#999999",
        navdirection: width > 800 ? "horizontal": "horizontal",
        navfeaturedarrowimage: "featuredarrow-16-8-1.png",
        navfeaturedarrowimageheight: 8,
        navfeaturedarrowimagewidth: 16,
        navfontcolor: "#333333",
        navfonthighlightcolor: "#666666",
        navfontsize: 12,
        navhighlightcolor: "#333333",
        navimage: width > 800 ? "bullet-24-24-0.png": "bullet-20-20-4.png",
        navlocation: "outside",
        navmarginx: width > 800 ? 16 : 8,
        navmarginy: width > 800 ? 16 : -4,
        navmultirows: false,
        navopacity: 0.8,
        navplaypauseimage: "navplaypause-32-32-0.png",
        navplayvideoimage: "play-32-32-0.png",
        navposition: width > 800 ? "bottom": "bottom",
        navpreviewarrowheight: 8,
        navpreviewarrowimage: "previewarrow-16-8-0.png",
        navpreviewarrowwidth: 16,
        navpreviewborder: 4,
        navpreviewbordercolor: "#ffffff",
        navpreviewheight: 60,
        navpreviewposition: "top",
        navpreviewwidth: 120,
        navradius: 0,
        navrowspacing: width > 800 ? 8 : 4,
        navshowarrow: true,
        navshowbuttons: false,
        navshowfeaturedarrow: false,
        navshowplaypause: true,
        navshowplaypausestandalone: false,
        navshowplaypausestandaloneautohide: false,
        navshowplaypausestandaloneheight: 32,
        navshowplaypausestandalonemarginx: 8,
        navshowplaypausestandalonemarginy: 8,
        navshowplaypausestandaloneposition: "bottomright",
        navshowplaypausestandalonewidth: 32,
        navshowplayvideo: true,
        navshowpreview: false,
        navshowpreviewontouch: false,
        navspacing: width > 800 ? 8 : 0,
        navstyle: width > 800 ? "thumbnails": "bullets",
        navswitchonmouseover: true,
        navthumbcolumn: 1,
        navthumbdescriptioncss: "display:block;position:relative;padding:2px 4px;text-align:left;font:normal 12px Arial,Helvetica,sans-serif;color:#333;",
        navthumbmediumcolumn: 8,
        navthumbmediumheight: 60,
        navthumbmediumsize: 800,
        navthumbmediumwidth: 40,
        navthumbnavigationarrowimage: width > 800 ? "carouselarrows-32-32-0.png": "carouselarrows-32-32-0.png",//"carouselarrows-32-32-1.png"
        navthumbnavigationarrowimageheight: 32,
        navthumbnavigationarrowimagewidth: 32,
        navthumbnavigationstyle: width > 800 ? "arrow": "auto",
        navthumbresponsive: true,
        navthumbresponsivemode: "samesize",
        navthumbsmallcolumn: 8,
        navthumbsmallheight: 60,
        navthumbsmallsize: 480,
        navthumbsmallwidth: 40,
        navthumbstyle: "imageonly",
        navthumbtitlecss: "display:block;position:relative;padding:2px 4px;text-align:left;font:bold 14px Arial,Helvetica,sans-serif;color:#333;",
        navthumbtitleheight: 20,
        navthumbtitlehovercss: "text-decoration:underline;",
        navthumbtitlewidth: 120,
        navwidth: width > 800 ? 30 : 20,
        navheight: width > 800 ? 45 : 20,
        numberingformat: "%NUM/%TOTAL ",
        pauseonmouseover: false,
        playmutedandinlinewhenautoplay: true,
        playvideoimage: "playvideo-64-64-0.png",
        playvideoimageheight: 64,
        playvideoimagewidth: 64,
        playvideoonclickthumb: true,
        randomplay: false,
        ribbonimage: "ribbon_topleft-0.png",
        ribbonimagex: 0,
        ribbonimagey: 0,
        ribbonposition: "topleft",
        scalemode: "flexheight", //flexheight, fill, fit
        shadowcolor: "#aaaaaa",
        shadowsize: 5,
        showbackgroundimage: false,
        showbottomshadow: false,
        showfacebook: true,
        shownumbering: false,
        showpinterest: true,
        showribbon: false,
        showshadow: false,
        showsocial: false,
        showtimer: false,
        showtwitter: true,
        skin: "Classic",
        skinsfoldername: "",
        slideinterval: 5000,
        socialmode: "mouseover",
        textautohide: true,
        textbgcss: "display:block; position:absolute; top:0px; left:0px; width:100%; height:100%; background-color:#333333; opacity:0.6; filter:alpha(opacity=60);",
        textcss: "display:block; padding:12px; text-align:left;",
        texteffect1: "slide",
        texteffect2: "slide",
        texteffect: "slide",
        texteffectdelay1: 1000,
        texteffectdelay2: 1500,
        texteffectdelay: 500,
        texteffectduration1: 600,
        texteffectduration2: 600,
        texteffectduration: 600,
        texteffecteasing1: "easeOutCubic",
        texteffecteasing2: "easeOutCubic",
        texteffecteasing: "easeOutCubic",
        texteffectresponsive: true,
        texteffectresponsivesize: 600,
        texteffectseparate: false,
        texteffectslidedirection1: "right",
        texteffectslidedirection2: "right",
        texteffectslidedirection: "left",
        texteffectslidedistance1: 120,
        texteffectslidedistance2: 120,
        texteffectslidedistance: 30,
        textformat: "Bottom bar",
        textpositiondynamic: "bottomleft",
        textpositionmarginbottom: 24,
        textpositionmarginleft: 24,
        textpositionmarginright: 24,
        textpositionmarginstatic: 0,
        textpositionmargintop: 24,
        textpositionstatic: "bottom",
        textstyle: "none",
        timercolor: "#ffffff",
        timerheight: 2,
        timeropacity: 0.6,
        timerposition: "bottom",
        titlecss: "display:block; position:relative; font:bold 14px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff;",
        titlecssresponsive: "font-size:12px;",
        transition: "cssslide",
        transitiononfirstslide: false,
        videohidecontrols: true,
        width: 600,
        cssslide: {
            duration: 1000,
            easing: "ease",
            checked: true
        },
        textformat: {}
    });
}

function amazing_init2(index) {
    var scripts = document.getElementsByTagName("script");
    var jsFolder = "";
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.match(/amazinginit72\.js/i))
          jsFolder = scripts[i].src.substr(0, scripts[i].src.lastIndexOf("/") + 1)
    }
    var width = document.documentElement.clientWidth;
  
    jQuery("#amazingslider-" + index).amazingslider72({
        sliderid: 1,
        addgooglefonts: false,
        addmargin: false,
        arrowheight: 32,
        arrowhideonmouseleave: 1000,
        arrowimage: "arrows-32-32-42.png",
        arrowmargin: 8,
        arrowstyle: "mouseover",
        arrowtop: 50,
        arrowwidth: 32,
        autoplay: false,
        autoplayvideo: true,
        backgroundimage: "",
        backgroundimagetop: -10,
        backgroundimagewidth: 120,
        border: 0,
        bordercolor: "#ffffff",
        borderradius: 0,
        bottomshadowimage: "bottomshadow-110-95-0.png",
        bottomshadowimagetop: 95,
        bottomshadowimagewidth: 96,
        buttoncss: "display:block; position:relative; margin-top:8px;",
        buttoncssresponsive: "",
        customcss: "",
        descriptioncss: "display:block; position:relative; font:12px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff; margin-top:8px;",
        descriptioncssresponsive: "font-size:12px;",
        donotresize: false,
        enabletouchswipe: true,
        forceflash: false,
        forceflashonie10: false,
        forceflashonie11: false,
        fullscreen: false,
        fullwidth: false,
        googlefonts: "",
        height: 900,
        initsocial: false,
        isfullscreen: false,
        isresponsive: true,
        jsfolder: jsFolder,
        lightboxbarheight: 64,
        lightboxdescriptionbottomcss: "{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}",
        lightboxshowdescription: false,
        lightboxshowfacebook: true,
        lightboxshownavigation: false,
        lightboxshowpinterest: true,
        lightboxshowsocial: false,
        lightboxshowtitle: true,
        lightboxshowtwitter: true,
        lightboxthumbbottommargin: 8,
        lightboxthumbheight: 60,
        lightboxthumbtopmargin: 12,
        lightboxthumbwidth: 80,
        lightboxtitlebottomcss: "{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}",
        loadimageondemand: false,
        loop: 0,
        navarrowimage: "navarrows-20-20-1.png",
        navborder: 1,
        navbordercolor: "#000000",
        navborderhighlightcolor: "#dddddd",
        navbuttonbgimage: "navbuttonbgimage-28-28-0.png",
        navbuttoncolor: "#999999",
        navbuttonhighlightcolor: "#333333",
        navbuttonradius: 0,
        navbuttonshowbgimage: true,
        navcolor: "#999999",
        navdirection: width > 800 ? "horizontal": "horizontal",
        navfeaturedarrowimage: "featuredarrow-16-8-1.png",
        navfeaturedarrowimageheight: 8,
        navfeaturedarrowimagewidth: 16,
        navfontcolor: "#333333",
        navfonthighlightcolor: "#666666",
        navfontsize: 12,
        navhighlightcolor: "#333333",
        navimage: width > 800 ? "bullet-24-24-0.png": "bullet-20-20-4.png",
        navlocation: "outside",
        navmarginx: width > 800 ? 16 : 8,
        navmarginy: width > 800 ? 16 : -4,
        navmultirows: false,
        navopacity: 0.8,
        navplaypauseimage: "navplaypause-32-32-0.png",
        navplayvideoimage: "play-32-32-0.png",
        navposition: width > 800 ? "bottom": "bottom",
        navpreviewarrowheight: 8,
        navpreviewarrowimage: "previewarrow-16-8-0.png",
        navpreviewarrowwidth: 16,
        navpreviewborder: 4,
        navpreviewbordercolor: "#ffffff",
        navpreviewheight: 60,
        navpreviewposition: "top",
        navpreviewwidth: 120,
        navradius: 0,
        navrowspacing: width > 800 ? 8 : 4,
        navshowarrow: true,
        navshowbuttons: false,
        navshowfeaturedarrow: false,
        navshowplaypause: true,
        navshowplaypausestandalone: false,
        navshowplaypausestandaloneautohide: false,
        navshowplaypausestandaloneheight: 32,
        navshowplaypausestandalonemarginx: 8,
        navshowplaypausestandalonemarginy: 8,
        navshowplaypausestandaloneposition: "bottomright",
        navshowplaypausestandalonewidth: 32,
        navshowplayvideo: true,
        navshowpreview: false,
        navshowpreviewontouch: false,
        navspacing: width > 800 ? 8 : 0,
        navstyle: width > 800 ? "thumbnails": "bullets",
        navswitchonmouseover: true,
        navthumbcolumn: 1,
        navthumbdescriptioncss: "display:block;position:relative;padding:2px 4px;text-align:left;font:normal 12px Arial,Helvetica,sans-serif;color:#333;",
        navthumbmediumcolumn: 8,
        navthumbmediumheight: 60,
        navthumbmediumsize: 800,
        navthumbmediumwidth: 40,
        navthumbnavigationarrowimage: width > 800 ? "carouselarrows-32-32-0.png": "carouselarrows-32-32-0.png",//"carouselarrows-32-32-1.png"
        navthumbnavigationarrowimageheight: 32,
        navthumbnavigationarrowimagewidth: 32,
        navthumbnavigationstyle: width > 800 ? "arrow": "auto",
        navthumbresponsive: true,
        navthumbresponsivemode: "samesize",
        navthumbsmallcolumn: 8,
        navthumbsmallheight: 60,
        navthumbsmallsize: 480,
        navthumbsmallwidth: 40,
        navthumbstyle: "imageonly",
        navthumbtitlecss: "display:block;position:relative;padding:2px 4px;text-align:left;font:bold 14px Arial,Helvetica,sans-serif;color:#333;",
        navthumbtitleheight: 20,
        navthumbtitlehovercss: "text-decoration:underline;",
        navthumbtitlewidth: 120,
        navwidth: width > 800 ? 30 : 20,
        navheight: width > 800 ? 45 : 20,
        numberingformat: "%NUM/%TOTAL ",
        pauseonmouseover: false,
        playmutedandinlinewhenautoplay: true,
        playvideoimage: "playvideo-64-64-0.png",
        playvideoimageheight: 64,
        playvideoimagewidth: 64,
        playvideoonclickthumb: true,
        randomplay: false,
        ribbonimage: "ribbon_topleft-0.png",
        ribbonimagex: 0,
        ribbonimagey: 0,
        ribbonposition: "topleft",
        scalemode: "flexheight", //flexheight, fill, fit
        shadowcolor: "#aaaaaa",
        shadowsize: 5,
        showbackgroundimage: false,
        showbottomshadow: false,
        showfacebook: true,
        shownumbering: false,
        showpinterest: true,
        showribbon: false,
        showshadow: false,
        showsocial: false,
        showtimer: false,
        showtwitter: true,
        skin: "Classic",
        skinsfoldername: "",
        slideinterval: 5000,
        socialmode: "mouseover",
        textautohide: true,
        textbgcss: "display:block; position:absolute; top:0px; left:0px; width:100%; height:100%; background-color:#333333; opacity:0.6; filter:alpha(opacity=60);",
        textcss: "display:block; padding:12px; text-align:left;",
        texteffect1: "slide",
        texteffect2: "slide",
        texteffect: "slide",
        texteffectdelay1: 1000,
        texteffectdelay2: 1500,
        texteffectdelay: 500,
        texteffectduration1: 600,
        texteffectduration2: 600,
        texteffectduration: 600,
        texteffecteasing1: "easeOutCubic",
        texteffecteasing2: "easeOutCubic",
        texteffecteasing: "easeOutCubic",
        texteffectresponsive: true,
        texteffectresponsivesize: 600,
        texteffectseparate: false,
        texteffectslidedirection1: "right",
        texteffectslidedirection2: "right",
        texteffectslidedirection: "left",
        texteffectslidedistance1: 120,
        texteffectslidedistance2: 120,
        texteffectslidedistance: 30,
        textformat: "Bottom bar",
        textpositiondynamic: "bottomleft",
        textpositionmarginbottom: 24,
        textpositionmarginleft: 24,
        textpositionmarginright: 24,
        textpositionmarginstatic: 0,
        textpositionmargintop: 24,
        textpositionstatic: "bottom",
        textstyle: "none",
        timercolor: "#ffffff",
        timerheight: 2,
        timeropacity: 0.6,
        timerposition: "bottom",
        titlecss: "display:block; position:relative; font:bold 14px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff;",
        titlecssresponsive: "font-size:12px;",
        transition: "cssslide",
        transitiononfirstslide: false,
        videohidecontrols: true,
        width: 600,
        cssslide: {
            duration: 1000,
            easing: "ease",
            checked: true
        },
        textformat: {}
    });
}

function amazing_init3(index) {
    var scripts = document.getElementsByTagName("script");
    var jsFolder = "";
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.match(/amazinginit72\.js/i))
          jsFolder = scripts[i].src.substr(0, scripts[i].src.lastIndexOf("/") + 1)
    }
    jQuery("#amazingslider-" + index).amazingslider72({
        sliderid: 1,
      	addgooglefonts:false,
        addmargin:true,
        arrowheight:48,
        arrowhideonmouseleave: 5000,
        arrowimage: "",
        arrowimagesvg: '<svg style="width: 12px;" viewBox="0 0 11 18"><path d="M 1.5 1.5 l 8 7.5 -8 7.5" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"></path></svg>',
        arrowmargin:0,
        arrowstyle:"mouseover",
        arrowtop:50,
        arrowwidth:48,
        autoplay: false,
        autoplayvideo: true,
        backgroundimage:"",
        backgroundimagetop:-10,
        backgroundimagewidth:120,
        border:0,
        bordercolor:"#ffffff",
        borderradius:0,
        bottomshadowimage:"bottomshadow-110-95-4.png",
        bottomshadowimagetop:98,
        bottomshadowimagewidth:110,
        buttoncss:"display:block; position:relative; margin-top:8px;",
        buttoncssresponsive:"",
        customcss:"",
        descriptioncss:"display:block; position:relative; font:12px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff; margin-top:8px;",
        descriptioncssresponsive:"font-size:12px;",
        donotresize:true,
        enabletouchswipe:true,
        fade: { duration:1000, easing:"easeOutCubic", checked:true },
        forceflash:false,
        forceflashonie10:false,
        forceflashonie11:false,
        fullscreen:false,
        fullwidth:false,
        googlefonts:"",
        initsocial:false,
        isfullscreen:false,
        isresponsive:true,
        jsfolder:jsFolder,
        lightboxbarheight:64,
        lightboxdescriptionbottomcss:"{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}",
        lightboxshowdescription:false,
        lightboxshowfacebook:false,
        lightboxshownavigation:true,
        lightboxshowpinterest:false,
        lightboxshowsocial:false,
        lightboxshowtitle:false,
        lightboxshowtwitter:false,
        lightboxthumbbottommargin:20,
        lightboxthumbheight:40,
        lightboxthumbtopmargin:20,
        lightboxthumbwidth:40,
        lightboxtitlebottomcss:"{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}",
        loadimageondemand:false,
        loop:0,
        navarrowimage:"navarrows-28-28-0.png",
        navborder:1,
        navbordercolor:"#ddd",
        navborderhighlightcolor:"",
        navbuttonbgimage:"navbuttonbgimage-28-28-0.png",
        navbuttoncolor:"",
        navbuttonhighlightcolor:"",
        navbuttonradius:0,
        navbuttonshowbgimage:true,
        navcolor:"#999999",
        navdirection:"vertical",
        navfeaturedarrowimage:"featuredarrow-8-16-9.png",
        navfeaturedarrowimageheight:16,
        navfeaturedarrowimagewidth:22,
        navfontcolor:"#333333",
        navfonthighlightcolor:"#666666",
        navfontsize:12,
        navheight:110,
        navhighlightcolor:"#333333",
        navimage:"bullet-24-24-5.png",
        navlocation: "outside",
        navmarginx:0,
        navmarginy:-84,
        navmultirows:false,
        navopacity:1.0,
        navplaypauseimage:"navplaypause-48-48-0.png",
        navplayvideoimage:"play-32-32-0.png",
        navposition:"left",
        navpreviewarrowheight:8,
        navpreviewarrowimage:"previewarrow-16-8-0.png",
        navpreviewarrowwidth:16,
        navpreviewborder:4,
        navpreviewbordercolor:"#ffffff",
        navpreviewheight:60,
        navpreviewposition:"top",
        navpreviewwidth:80,
        navradius:0,
        navrowspacing:12,
        navshowarrow: false,
        navshowbuttons:false,
        navshowfeaturedarrow:true,
        navshowplaypause:true,
        navshowplaypausestandalone:false,
        navshowplaypausestandaloneautohide:true,
        navshowplaypausestandaloneheight:48,
        navshowplaypausestandalonemarginx: 8,
        navshowplaypausestandalonemarginy: 8,
        navshowplaypausestandaloneposition: "bottomright",
        navshowplaypausestandalonewidth: 48,
        navshowplayvideo: true,
        navshowpreview: false,
        navshowpreviewontouch: false,
        navspacing: 16,
        navstyle:"thumbnails",
        navswitchonmouseover: true,
        navthumbcolumn:5,
        navthumbdescriptioncss: "display:block;position:relative;padding:2px 4px;text-align:left;font:normal 12px Arial,Helvetica,sans-serif;color:#333;",
        navthumbmediumcolumn: 4,
        navthumbmediumheight: 64,
        navthumbmediumsize: 800,
        navthumbmediumwidth: 64,
        navthumbnavigationarrowimage:"",
        navthumbnavigationarrowimagewidth: 80,
        navthumbnavigationarrowimageheight: 32,
        navthumbnavigationarrowsvg: '<svg viewBox="-2 -2 20 12" style="width: 22px;"><path stroke-width="2" stroke="currentColor" fill="none" d="M 0 8 l 8 -8 l 8 8" stroke-linecap="round"></path></svg>',
        navthumbnavigationstyle:"arrowinside",
        navthumbresponsive:true,
        navthumbresponsivemode:"samesize",
        navthumbsmallcolumn:3,
        navthumbsmallheight:48,
        navthumbsmallsize:480,
        navthumbsmallwidth:48,
        navthumbstyle:"imageonly",
        navthumbtitlecss:"display:block;position:relative;padding:2px 4px;text-align:left;font:bold 14px Arial,Helvetica,sans-serif;color:#333;",
        navthumbtitleheight:20,
        navthumbtitlehovercss:"text-decoration:underline;",
        navthumbtitlewidth:80,
        navwidth:100,
        numberingformat:"%NUM/%TOTAL ",
        pauseonmouseover:true,
        playvideoimage:"playvideo-64-64-0.png",
        playvideoimageheight:64,
        playvideoimagewidth:64,
        playvideoonclickthumb:true,
        randomplay:false,
        ribbonimage:"ribbon_topleft-0.png",
        ribbonimagex:0,
        ribbonimagey:0,
        ribbonposition:"topleft",
        scalemode:"fit",
        scalemode:"fit",
        shadowcolor:"#aaaaaa",
        shadowsize:5,
        showbackgroundimage:false,
        showbottomshadow:false,
        showfacebook:true,
        shownumbering:false,
        showpinterest:true,
        showribbon:false,
        showshadow:false,
        showsocial:false,
        showtimer:true,
        showtwitter:true,
        skin:"TopCarousel",
        skinsfoldername:"",
        slideinterval:5000,
        slidermarginx:88,
        socialmode:"mouseover",
        textautohide:true,
        textbgcss:"display:block; position:absolute; top:0px; left:0px; width:100%; height:100%; background-color:#333333; opacity:0.6; filter:alpha(opacity=60);",
        textcss:"display:block; padding:12px; text-align:left;",
        texteffect:"slide",
        texteffect1:"slide",
        texteffect2:"slide",
        texteffectdelay:500,
        texteffectdelay1:1000,
        texteffectdelay2:1500,
        texteffectduration:600,
        texteffectduration1:600,
        texteffectduration2:600,
        texteffecteasing:"easeOutCubic",
        texteffecteasing1:"easeOutCubic",
        texteffecteasing2:"easeOutCubic",
        texteffectresponsive:true,
        texteffectresponsivesize:600,
        texteffectseparate:false,
        texteffectslidedirection:"left",
        texteffectslidedirection1:"right",
        texteffectslidedirection2:"right",
        texteffectslidedistance:30,
        texteffectslidedistance1:120,
        texteffectslidedistance2:120,
        textformat: {},
        textformat:"None",
        textpositiondynamic:"bottomleft",
        textpositionmarginbottom:24,
        textpositionmarginleft:24,
        textpositionmarginright:24,
        textpositionmarginstatic:0,
        textpositionmargintop:24,
        textpositionstatic:"bottom",
        textstyle:"none",
        timercolor:"#ffffff",
        timerheight:1,
        timeropacity:1.0,
        timerposition:"bottom",
        titlecss:"display:block; position:relative; font:bold 14px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff;",
        titlecssresponsive:"font-size:12px;",
        transition:"fade",
        transitiononfirstslide:false,
        videohidecontrols:false,
        width:600,
        height:660
    });
}

function amazing_init4(index, widescreen) {
    var scripts = document.getElementsByTagName("script");
    var jsFolder = "";
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.match(/amazinginit72\.js/i))
          jsFolder = scripts[i].src.substr(0, scripts[i].src.lastIndexOf("/") + 1)
    }
    jQuery("#amazingslider-" + index).amazingslider72({
        sliderid: 1,
        addgooglefonts: false,
        addmargin: false,
        arrowheight: 32,
        arrowhideonmouseleave: 5000,
        arrowimage: "",
        arrowimagesvg: '<svg style="width: 12px; margin: auto; position: absolute; top: 50%; transform: translateY(-50%); left: 0; right: 0;" viewBox="0 0 11 18"><path d="M 1.5 1.5 l 8 7.5 -8 7.5" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"></path></svg>',
        arrowmargin: 8,
        arrowstyle: "mouseover",
        arrowtop: 50,
        arrowwidth: 32,
        autoplay: false,
        autoplayvideo: true,
        backgroundimage: "",
        backgroundimagetop: -10,
        backgroundimagewidth: 100,
        border: 0,
        bordercolor: "#ffffff",
        borderradius: 0,
        bottomshadowimage: "bottomshadow-110-95-0.png",
        bottomshadowimagetop: 95,
        bottomshadowimagewidth: 96,
        buttoncss: "display:block; position:relative; margin-top:8px;",
        buttoncssresponsive: "",
        customcss: "",
        descriptioncss: "display:block; position:relative; font:12px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff; margin-top:8px;",
        descriptioncssresponsive: "font-size:12px;",
        donotresize: false,
        enabletouchswipe: true,
        forceflash: false,
        forceflashonie10: false,
        forceflashonie11: false,
        fullscreen: false,
        fullwidth: false,
        googlefonts: "",
        initsocial: false,
        isfullscreen: false,
        isresponsive: true,
        jsfolder: jsFolder,
        lightboxbarheight: 64,
        lightboxdescriptionbottomcss: "{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}",
        lightboxshowdescription: false,
        lightboxshowfacebook: true,
        lightboxshownavigation: false,
        lightboxshowpinterest: true,
        lightboxshowsocial: false,
        lightboxshowtitle: true,
        lightboxshowtwitter: true,
        lightboxthumbbottommargin: 8,
        lightboxthumbheight: 60,
        lightboxthumbtopmargin: 12,
        lightboxthumbwidth: 100,
        lightboxtitlebottomcss: "{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}",
        loadimageondemand: false,
        loop: 0,
        loopvideo: true,
        navarrowimage: "navarrows-20-20-1.png",
        navborder: 1,
        navbordercolor: "#000000",
        navborderhighlightcolor: "#dddddd",
        navbuttonbgimage: "navbuttonbgimage-28-28-0.png",
        navbuttoncolor: "#999999",
        navbuttonhighlightcolor: "#333333",
        navbuttonradius: 0,
        navbuttonshowbgimage: true,
        navcolor: "#999999",
        navdirection: widescreen ? "horizontal": "horizontal",
        navfeaturedarrowimage: "featuredarrow-16-8-1.png",
        navfeaturedarrowimageheight: 8,
        navfeaturedarrowimagewidth: 16,
        navfontcolor: "#333333",
        navfonthighlightcolor: "#666666",
        navfontsize: 12,
        navhighlightcolor: "#333333",
        navimage: widescreen ? "bullet-24-24-0.png": "bullet-20-20-4.png",
        navlocation: "outside",
        navmarginx: widescreen ? 16 : 8,
        navmarginy: 3,
        navmultirows: false,
        navopacity: 0.8,
        navplaypauseimage: "navplaypause-32-32-0.png",
        navplayvideoimage: "play-32-32-0.png",
        navposition: widescreen ? "bottom": "bottom",
        navpreviewarrowheight: 8,
        navpreviewarrowimage: "previewarrow-16-8-0.png",
        navpreviewarrowwidth: 16,
        navpreviewborder: 4,
        navpreviewbordercolor: "#ffffff",
        navpreviewheight: 60,
        navpreviewposition: "top",
        navpreviewwidth: 100,
        navradius: 0,
        navrowspacing: widescreen ? 8 : 4,
        navshowarrow: true,
        navshowbuttons: false,
        navshowfeaturedarrow: false,
        navshowplaypause: true,
        navshowplaypausestandalone: false,
        navshowplaypausestandaloneautohide: false,
        navshowplaypausestandaloneheight: 32,
        navshowplaypausestandalonemarginx: 8,
        navshowplaypausestandalonemarginy: 8,
        navshowplaypausestandaloneposition: "bottomright",
        navshowplaypausestandalonewidth: 32,
        navshowplayvideo: true,
        navshowpreview: false,
        navshowpreviewontouch: false,
        navspacing: widescreen ? 0 : 0,
        navstyle: "bullets", //"thumbnails"
        navswitchonmouseover: true,
        navthumbcolumn: 1,
        navthumbdescriptioncss: "display:block;position:relative;padding:2px 4px;text-align:left;font:normal 12px Arial,Helvetica,sans-serif;color:#333;",
        navthumbmediumcolumn: 8,
        navthumbmediumheight: 50,
        navthumbmediumsize: 800,
        navthumbmediumwidth: 50,
        navthumbnavigationarrowimage: widescreen ? "carouselarrows-32-32-0.png": "carouselarrows-32-32-0.png",//"carouselarrows-32-32-1.png"
        navthumbnavigationarrowimageheight: 32,
        navthumbnavigationarrowimagewidth: 32,
        navthumbnavigationstyle: widescreen ? "arrowinside": "auto",//"arrow","arrowoutside"
        navthumbresponsive: true,
        navthumbresponsivemode: "samesize",
        navthumbsmallcolumn: 8,
        navthumbsmallheight: 50,
        navthumbsmallsize: 480,
        navthumbsmallwidth: 50,
        navthumbstyle: "imageonly",
        navthumbtitlecss: "display:block;position:relative;padding:2px 4px;text-align:left;font:bold 14px Arial,Helvetica,sans-serif;color:#333;",
        navthumbtitleheight: 20,
        navthumbtitlehovercss: "text-decoration:underline;",
        navthumbtitlewidth: 100,
        navwidth: widescreen ? 24 : 20,
        navheight: widescreen ? 24 : 20,
        numberingformat: "%NUM/%TOTAL ",
        pauseonmouseover: false,
        playmutedandinlinewhenautoplay: true,
        playvideoimage: "playvideo-64-64-0.png",
        playvideoimageheight: 64,
        playvideoimagewidth: 64,
        playvideoonclickthumb: true,
        randomplay: false,
        ribbonimage: "ribbon_topleft-0.png",
        ribbonimagex: 0,
        ribbonimagey: 0,
        ribbonposition: "topleft",
        scalemode: "fit",
        shadowcolor: "#aaaaaa",
        shadowsize: 5,
        showbackgroundimage: false,
        showbottomshadow: false,
        showfacebook: true,
        shownumbering: false,
        showpinterest: true,
        showribbon: false,
        showshadow: false,
        showsocial: false,
        showtimer: false,
        showtwitter: true,
        skin: "Classic",
        skinsfoldername: "",
        slideinterval: 5000,
        socialmode: "mouseover",
        textautohide: true,
        textbgcss: "display:block; position:absolute; top:0px; left:0px; width:100%; height:100%; background-color:#333333; opacity:0.6; filter:alpha(opacity=60);",
        textcss: "display:block; padding:12px; text-align:left;",
        texteffect1: "slide",
        texteffect2: "slide",
        texteffect: "slide",
        texteffectdelay1: 1000,
        texteffectdelay2: 1500,
        texteffectdelay: 500,
        texteffectduration1: 600,
        texteffectduration2: 600,
        texteffectduration: 600,
        texteffecteasing1: "easeOutCubic",
        texteffecteasing2: "easeOutCubic",
        texteffecteasing: "easeOutCubic",
        texteffectresponsive: true,
        texteffectresponsivesize: 600,
        texteffectseparate: false,
        texteffectslidedirection1: "right",
        texteffectslidedirection2: "right",
        texteffectslidedirection: "left",
        texteffectslidedistance1: 120,
        texteffectslidedistance2: 120,
        texteffectslidedistance: 30,
        textformat: "Bottom bar",
        textpositiondynamic: "bottomleft",
        textpositionmarginbottom: 24,
        textpositionmarginleft: 24,
        textpositionmarginright: 24,
        textpositionmarginstatic: 0,
        textpositionmargintop: 24,
        textpositionstatic: "bottom",
        textstyle: "none",
        timercolor: "#ffffff",
        timerheight: 2,
        timeropacity: 0.6,
        timerposition: "bottom",
        titlecss: "display:block; position:relative; font:bold 14px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff;",
        titlecssresponsive: "font-size:12px;",
        transition: "cssslide",
        transitiononfirstslide: false,
        videohidecontrols: true,
        cssslide: {
            duration: 1000,
            easing: "ease",
            checked: true
        },
        textformat: {},
        width: 600,
        height: 900
    });
}


function amazing_init5(index) {
    var scripts = document.getElementsByTagName("script");
    var jsFolder = "";
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src && scripts[i].src.match(/amazinginit72\.js/i))
          jsFolder = scripts[i].src.substr(0, scripts[i].src.lastIndexOf("/") + 1)
    }
    jQuery("#amazingslider-" + index).amazingslider72({
        sliderid: 1,
        addgooglefonts: false,
        addmargin: false,
        arrowheight:48,
        arrowhideonmouseleave: 5000,
        arrowimage: "",
        arrowimagesvg: '<svg style="width: 12px;" viewBox="0 0 11 18"><path d="M 1.5 1.5 l 8 7.5 -8 7.5" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"></path></svg>',
        arrowmargin:0,
        arrowstyle:"mouseover",
        arrowtop:50,
        arrowwidth:48,
        autoplay: false,
        autoplayvideo: true,
        loopvideo: true,
        backgroundimage: "",
        backgroundimagetop: -10,
        backgroundimagewidth: 120,
        border: 0,
        bordercolor: "#ffffff",
        borderradius: 0,
        bottomshadowimage: "bottomshadow-110-95-0.png",
        bottomshadowimagetop: 95,
        bottomshadowimagewidth: 96,
        buttoncss: "display:block; position:relative; margin-top:8px;",
        buttoncssresponsive: "",
        customcss: "",
        descriptioncss: "display:block; position:relative; font:12px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff; margin-top:8px;",
        descriptioncssresponsive: "font-size:12px;",
        donotresize: false,
        enabletouchswipe:true,
        fade: { duration:1000, easing:"easeOutCubic", checked:true },
        forceflash: false,
        forceflashonie10: false,
        forceflashonie11: false,
        fullscreen: false,
        fullwidth: false,
        googlefonts: "",
        initsocial: false,
        isfullscreen: false,
        isresponsive: true,
        jsfolder: jsFolder,
        lightboxbarheight: 64,
        lightboxdescriptionbottomcss: "{color:#333; font-size:12px; font-family:Arial,Helvetica,sans-serif; overflow:hidden; text-align:left; margin:4px 0px 0px; padding: 0px;}",
        lightboxshowdescription: false,
        lightboxshowfacebook:false,
        lightboxshownavigation:true,
        lightboxshowpinterest:false,
        lightboxshowsocial:false,
        lightboxshowtitle:false,
        lightboxshowtwitter:false,
        lightboxthumbbottommargin: 8,
        lightboxthumbheight: 60,
        lightboxthumbtopmargin: 12,
        lightboxthumbwidth: 80,
        lightboxtitlebottomcss: "{color:#333; font-size:14px; font-family:Armata,sans-serif,Arial; overflow:hidden; text-align:left;}",
        loadimageondemand: false,
        loop: 0,
        navarrowimage: "navarrows-20-20-1.png",
        navborder: 1,
        navbordercolor:"#ddd",
        navborderhighlightcolor:"",
        navbuttonbgimage: "navbuttonbgimage-28-28-0.png",
        navbuttoncolor:"",
        navbuttonhighlightcolor:"",
        navbuttonradius: 0,
        navbuttonshowbgimage: true,
        navcolor: "#999999",
        navdirection: "horizontal",
        navfeaturedarrowimage: "featuredarrow-16-8-1.png",
        navfeaturedarrowimageheight:16,
        navfeaturedarrowimagewidth:22,
        navfontcolor: "#333333",
        navfonthighlightcolor: "#666666",
        navfontsize: 12,
        navheight: 110,
        navhighlightcolor: "#333333",
        navimage: "bullet-24-24-0.png",
        navlocation: "outside",
        navmarginx: 6,
        navmarginy: 16,
        navmultirows: false,
        navopacity: 1.0,
        navplaypauseimage: "navplaypause-32-32-0.png",
        navplayvideoimage: "play-32-32-0.png",
        navposition: "bottom",
        navpreviewarrowheight: 8,
        navpreviewarrowimage: "previewarrow-16-8-0.png",
        navpreviewarrowwidth: 16,
        navpreviewborder: 4,
        navpreviewbordercolor: "#ffffff",
        navpreviewheight: 60,
        navpreviewposition: "top",
        navpreviewwidth: 120,
        navradius: 0,
        navrowspacing: 8,
        navshowarrow: true,
        navshowbuttons: false,
        navshowfeaturedarrow: false,
        navshowplaypause: true,
        navshowplaypausestandalone: false,
        navshowplaypausestandaloneautohide: false,
        navshowplaypausestandaloneheight: 48,
        navshowplaypausestandalonemarginx: 8,
        navshowplaypausestandalonemarginy: 8,
        navshowplaypausestandaloneposition: "bottomright",
        navshowplaypausestandalonewidth: 48,
        navshowplayvideo: true,
        navshowpreview: false,
        navshowpreviewontouch: false,
        navspacing: 6,
        navstyle: "thumbnails",
        navswitchonmouseover: true,
        navthumbcolumn: 1,
        navthumbdescriptioncss: "display:block;position:relative;padding:2px 4px;text-align:left;font:normal 12px Arial,Helvetica,sans-serif;color:#333;",
        navthumbmediumcolumn: 8,
        navthumbmediumheight: 60,
        navthumbmediumsize: 800,
        navthumbmediumwidth: 40,
        navthumbnavigationarrowimage: "",//"carouselarrows-32-32-0.png"
        navthumbnavigationarrowimageheight: 32,
        navthumbnavigationarrowimagewidth: 32,
        navthumbnavigationarrowsvg: '<svg viewBox="0 0 11 18" style="width: 12px;"><path d="M 9.5 1.5 l -8 7.5 8 7.5" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"></path></svg>',
        navthumbnavigationstyle: "arrowinside",//"arrow"
        navthumbresponsive: true,
        navthumbresponsivemode: "samesize",
        navthumbsmallcolumn: 8,
        navthumbsmallheight: 60,
        navthumbsmallsize: 480,
        navthumbsmallwidth: 40,
        navthumbstyle: "imageonly",
        navthumbtitlecss: "display:block;position:relative;padding:2px 4px;text-align:left;font:bold 14px Arial,Helvetica,sans-serif;color:#333;",
        navthumbtitleheight: 20,
        navthumbtitlehovercss: "text-decoration:underline;",
        navthumbtitlewidth: 120,
        navwidth: 100,
        numberingformat: "%NUM/%TOTAL ",
        pauseonmouseover: false,
        playmutedandinlinewhenautoplay: true,
        playvideoimage: "playvideo-64-64-0.png",
        playvideoimageheight: 64,
        playvideoimagewidth: 64,
        playvideoonclickthumb: true,
        randomplay: false,
        ribbonimage: "ribbon_topleft-0.png",
        ribbonimagex: 0,
        ribbonimagey: 0,
        ribbonposition: "topleft",
        scalemode: "fill",
        scalemode: "fill",
        shadowcolor: "#aaaaaa",
        shadowsize: 5,
        showbackgroundimage: false,
        showbottomshadow: false,
        showfacebook: true,
        shownumbering: false,
        showpinterest: true,
        showribbon: false,
        showshadow: false,
        showsocial: false,
        showtimer: false,
        showtwitter: true,
        skin: "Classic",
        skinsfoldername: "",
        slideinterval: 5000,
        sliderid: 1,
        socialmode: "mouseover",
        textautohide: true,
        textbgcss: "display:block; position:absolute; top:0px; left:0px; width:100%; height:100%; background-color:#333333; opacity:0.6; filter:alpha(opacity=60);",
        textcss: "display:block; padding:12px; text-align:left;",
        texteffect1: "slide",
        texteffect2: "slide",
        texteffect: "slide",
        texteffectdelay1: 1000,
        texteffectdelay2: 1500,
        texteffectdelay: 500,
        texteffectduration1: 600,
        texteffectduration2: 600,
        texteffectduration: 600,
        texteffecteasing1: "easeOutCubic",
        texteffecteasing2: "easeOutCubic",
        texteffecteasing: "easeOutCubic",
        texteffectresponsive: true,
        texteffectresponsivesize: 600,
        texteffectseparate: false,
        texteffectslidedirection1: "right",
        texteffectslidedirection2: "right",
        texteffectslidedirection: "left",
        texteffectslidedistance1: 120,
        texteffectslidedistance2: 120,
        texteffectslidedistance: 30,
        textformat: "Bottom bar",
        textpositiondynamic: "bottomleft",
        textpositionmarginbottom: 24,
        textpositionmarginleft: 24,
        textpositionmarginright: 24,
        textpositionmarginstatic: 0,
        textpositionmargintop: 24,
        textpositionstatic: "bottom",
        textstyle: "none",
        timercolor: "#ffffff",
        timerheight: 2,
        timeropacity: 0.6,
        timerposition: "bottom",
        titlecss: "display:block; position:relative; font:bold 14px \"Lucida Sans Unicode\",\"Lucida Grande\",sans-serif,Arial; color:#fff;",
        titlecssresponsive: "font-size:12px;",
        transition: "cssslide",
        transitiononfirstslide: false,
        videohidecontrols: true,
        width: 600,
		height:600,
        cssslide: {
            duration: 1000,
            easing: "ease",
            checked: true
        },
        textformat: {}
    });
}